export default () => ({
  trigger: {
    name: 'shopping_cart_dropdown.open_shopping_cart_dropdown',
    params: {},
  },
  config: {
    event: {
      name: 'open_menu',
      params: {
        sub_feature: null,
        content: null,
      },
    },
  },
});
